import Footer from "../Homepages/Footer";
import {
  BsArrowLeft,
  BsHeartFill,
  BsHandbag,
  BsHandIndexThumb,
} from "react-icons/bs";
import { FaHeartBroken, FaMoneyCheckAlt, FaChurch, FaHospital } from "react-icons/fa";
import { GiDiscGolfBag } from "react-icons/gi";
import { setUser } from "../../reducers/userReducer";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

export default function AffirmIntro() {
  const navigate = useNavigate();
  const username = useSelector(setUser);
  return (
    <div className="container px-4 mb-5">
      <div className="heading mb-3 mt-4">
        <BsArrowLeft
          size="30px"
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/home");
          }}
        />
        <h3 className="text-center no-wrap">My Affirmations</h3>
      </div>
      <div className="container mb-5">
        <h4>
          Hey <span style={{ fontWeight: "bolder" }}>{username}</span>
        </h4>
        <h1 style={{ fontWeight: "bolder", fontSize: "35px" }} className="my-4">
          Choose an affirmation topic
        </h1>
        <div>
          <div className="affs" style={{color:"#000"}}>
            <Link to="/affirm/prosperity" className="link links"><h6 className="aff d-flex align-items-center gap-2">
              <span>
                <BsHandbag color="pink" size="25px"/>
              </span>{" "}
              Prosperity
            </h6>
            </Link>
            <h6 className="aff d-flex align-items-center gap-2">
              <span>
                <BsHeartFill size="25px" color="red"/>
              </span>{" "}
              Love
            </h6>
            <h6 className="aff d-flex align-items-center gap-2">
              <span>
                <BsHandIndexThumb size="25px"/>
              </span>{" "}
              I am
            </h6>
            <h6 className="aff d-flex align-items-center gap-2">
              <span>
               👨‍👩‍👧‍👦 
              </span>{" "}
               Family
            </h6>
            <h6 className="aff d-flex align-items-center gap-2">
              <span>
                <BsHeartFill size="25px"/>
              </span>{" "}
              Self Esteem
            </h6>
            <h6 className="aff d-flex align-items-center gap-2">
              <span>
                <FaChurch size="25px" color="green"/>
              </span>{" "}
              Spiritual
            </h6>
            <h6 className="aff d-flex align-items-center gap-2">
              <span>
                <BsHeartFill size="25px"/>
              </span>{" "}
              Beauty
            </h6>
            <h6 className="aff d-flex align-items-center gap-2">
              <span>
                <FaMoneyCheckAlt size="25px"/>
              </span>{" "}
              Success
            </h6>
            <h6 className="aff d-flex align-items-center gap-2">
              <span>
                <BsHeartFill size="25px"/>
              </span>{" "}
              Relationship
            </h6>
            <h6 className="aff d-flex align-items-center gap-2">
              <span>
                <FaHospital size="25px" color="silver"/>
              </span>{" "}
              Health
            </h6>
            <h6 className="aff d-flex align-items-center gap-2">
              <span>
                <GiDiscGolfBag size="25px" color="brown"/>
              </span>{" "}
              Business
            </h6>
            <h6 className="aff d-flex align-items-center gap-2">
              <span>
                <FaHeartBroken size="25px" color="red"/>
              </span>{" "}
              Forgiveness
            </h6>
            <h6 className="aff d-flex align-items-center gap-2">
              <span>
                <BsHeartFill size="25px"/>
              </span>{" "}
              Self Improvement
            </h6>
            <h6 className="aff d-flex align-items-center gap-2">
              <span>
              💪 
              </span>{" "}
              I can
            </h6>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
